var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrlegalLogo25Clr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "coop-logotype",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 368.2 107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        mask: url(#mask);\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        fill: #183835;\n      }\n    "), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 2.9,
    y: 8.9,
    width: 86.2,
    height: 88,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "path-1",
    className: "st1",
    cx: 46,
    cy: 52.9,
    rx: 43.1,
    ry: 44
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guidelines"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hr-logo-copy"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group1",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st2",
    d: "M89.2,8.9v87.7h-23.3s0-38,0-38c0,0-12.7,10.1-13,16.8v.2s0,21,0,21H2.9S2.9,8.9,2.9,8.9h86.2ZM78.8,9.2h-13v36.4H25.9h0c-.5.4-13,10.5-13,17v32.3h13v-36.4s39.9,0,39.9,0c0,0,13-10.3,13-17V9.2ZM38.9,9.5h-13v36s13-10.3,13-17V9.5Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "hr-legal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st2",
    d: "M139.7,78.5v-20.1c0-1,0-2.2-.2-3.7s-.4-3-1-4.6c-.6-1.5-1.4-2.8-2.7-3.8-1.2-1-3-1.5-5.3-1.5s-1.9.1-2.9.4c-1,.3-2,.8-2.9,1.7-.9.8-1.7,2-2.3,3.6-.6,1.6-.9,3.7-.9,6.4l-6.1-2.9c0-3.4.7-6.5,2-9.5,1.4-2.9,3.4-5.3,6.2-7.1,2.7-1.8,6.2-2.7,10.4-2.7s6,.6,8.1,1.7c2.1,1.1,3.7,2.6,4.9,4.3,1.2,1.7,2,3.5,2.5,5.4.5,1.9.8,3.6.9,5.1.1,1.6.2,2.7.2,3.4v23.9h-10.9ZM110.7,78.5V21.7h9.5v29.2h1.3v27.6h-10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st2",
    d: "M157.8,78.5v-42.8h9.3v10.5l-1-1.3c.5-1.5,1.3-2.8,2.2-4s2-2.2,3.3-3c1-.6,2.1-1.1,3.3-1.5,1.2-.4,2.4-.6,3.7-.7s2.5,0,3.8,0v10.1c-1.2-.4-2.5-.5-4.1-.4-1.5.1-2.9.5-4.2,1.1-1.2.6-2.3,1.4-3.1,2.3s-1.5,2.1-1.9,3.4c-.4,1.3-.7,2.8-.7,4.4v21.9h-10.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path1",
    "data-name": "Path",
    className: "st2",
    points: "200.6 77.7 200.6 20.3 211.5 20.3 211.5 77.7 200.6 77.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape1",
    "data-name": "Shape",
    className: "st2",
    d: "M240,79.2c-4.3,0-8.2-.9-11.5-2.8s-5.9-4.5-7.8-7.8c-1.9-3.3-2.8-7.1-2.8-11.4s.9-8.7,2.7-12.2c1.8-3.5,4.3-6.1,7.6-8.1,3.2-1.9,6.9-2.9,11.1-2.9s8.2,1.1,11.3,3.2c3.1,2.1,5.4,5.1,6.9,8.9,1.5,3.8,2,8.3,1.6,13.5h-10.5v-4c0-4.4-.7-7.5-2.1-9.4-1.4-1.9-3.6-2.9-6.7-2.9s-6.3,1.1-8,3.3-2.6,5.5-2.6,9.9.9,7.1,2.6,9.2,4.2,3.3,7.5,3.3,3.9-.5,5.4-1.4c1.5-.9,2.6-2.3,3.4-4l10.7,3.1c-1.6,3.9-4.1,6.9-7.5,9.1-3.4,2.2-7.2,3.2-11.3,3.2ZM226,59.7v-8h28v8h-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape2",
    "data-name": "Shape",
    className: "st2",
    d: "M283.6,98.1c-2.4,0-4.7-.4-6.9-1.2-2.2-.8-4.1-1.9-5.9-3.2-1.7-1.4-3.1-3-4.2-4.8l10-4.8c.7,1.3,1.7,2.2,2.9,2.9,1.3.7,2.7,1,4.2,1s3.1-.3,4.5-.8c1.4-.5,2.6-1.3,3.4-2.4.9-1.1,1.3-2.4,1.2-4v-12.4h1.3v-33h9.4v45.6c0,1.1,0,2-.1,3,0,.9-.3,1.9-.5,2.8-.7,2.6-2,4.8-3.8,6.4-1.9,1.7-4.1,2.9-6.8,3.8-2.7.8-5.6,1.2-8.7,1.2ZM282.6,79.1c-3.9,0-7.4-1-10.3-3-2.9-2-5.2-4.7-6.9-8.1-1.6-3.4-2.5-7.2-2.5-11.5s.8-8.2,2.5-11.6c1.7-3.4,4-6.1,7-8,3-2,6.6-2.9,10.7-2.9s7.5,1,10.2,3,4.9,4.7,6.3,8.1c1.4,3.4,2.1,7.2,2.1,11.5s-.7,8.1-2.2,11.5c-1.4,3.4-3.6,6.1-6.4,8.1-2.8,2-6.4,3-10.6,3ZM284.3,69.6c2.4,0,4.3-.5,5.7-1.6,1.4-1.1,2.5-2.6,3.1-4.5.6-2,.9-4.2.9-6.8s-.3-4.8-.9-6.8c-.6-2-1.6-3.5-3-4.5-1.4-1.1-3.2-1.6-5.4-1.6s-4.4.6-5.9,1.8-2.7,2.7-3.4,4.7-1.1,4.1-1.1,6.5.4,4.6,1.1,6.5c.7,2,1.8,3.5,3.3,4.7,1.5,1.2,3.4,1.7,5.7,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape3",
    "data-name": "Shape",
    className: "st2",
    d: "M323.4,79.2c-3,0-5.6-.6-7.7-1.8s-3.7-2.7-4.8-4.7c-1.1-2-1.6-4.1-1.6-6.5s.3-3.8.9-5.4c.6-1.6,1.6-3.1,2.9-4.3,1.3-1.3,3.1-2.3,5.4-3.1,1.6-.6,3.4-1.1,5.6-1.5s4.6-.9,7.3-1.3c2.7-.4,5.7-.9,9-1.4l-3.8,2.1c0-2.5-.6-4.4-1.8-5.6s-3.2-1.8-6-1.8-3.2.4-4.9,1.1-2.9,2.1-3.6,4.1l-9.6-3.1c1.1-3.5,3.1-6.4,6-8.6,2.9-2.2,6.9-3.3,12-3.3s7,.6,9.9,1.7,5.1,3.2,6.6,6c.8,1.6,1.3,3.2,1.5,4.7s.2,3.4.2,5.3v26.1h-9.3v-8.8l1.3,1.8c-2.1,2.9-4.3,5-6.7,6.2-2.4,1.3-5.4,1.9-9,1.9ZM325.6,70.7c2,0,3.6-.3,4.9-1,1.3-.7,2.4-1.5,3.2-2.4s1.3-1.6,1.6-2.3c.5-1.2.9-2.5,1-4.1s.1-2.8.1-3.9l3.1.8c-3.1.5-5.7,1-7.6,1.3-2,.4-3.5.7-4.7,1-1.2.3-2.3.6-3.2.9-1,.4-1.9.9-2.5,1.4-.6.5-1.1,1-1.4,1.6-.3.6-.4,1.2-.4,1.9s.2,1.8.7,2.5,1.2,1.2,2,1.6c.9.4,1.9.6,3.2.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path2",
    "data-name": "Path",
    className: "st2",
    points: "354.4 77.7 354.4 20.3 365.3 20.3 365.3 77.7 354.4 77.7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrlegalLogo25Clr);
export default __webpack_public_path__ + "static/media/hrlegal_logo25_clr.ef13ce5971e600a80264d265ddb8414b.svg";
export { ForwardRef as ReactComponent };